import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import React from 'react';
import TooltipProps from '../types/TooltipProps';

export const Tooltip: React.FC<TooltipProps> = ({ content, children }) => {
  return (
    <TooltipPrimitive.Provider>
      <TooltipPrimitive.Root>
        <TooltipPrimitive.Trigger asChild>
          <span className="cursor-help border-b border-dotted border-gray-500">
            {children}
          </span>
        </TooltipPrimitive.Trigger>
        <TooltipPrimitive.Portal>
          <TooltipPrimitive.Content
            className="bg-gray-900 text-white px-4 py-2 rounded-lg text-sm max-w-xs shadow-lg z-50"
            sideOffset={5}
          >
            {content}
            <TooltipPrimitive.Arrow className="fill-gray-900" />
          </TooltipPrimitive.Content>
        </TooltipPrimitive.Portal>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
};
